var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M465.173,123.627c-0.64-1.387-1.493-2.667-2.56-3.733L345.387,3.413C343.147,1.28,340.16,0,337.067,0H151.36 c-6.4,0-11.627,5.227-11.627,11.627v0.107v35.2h-35.307c-6.4,0-11.627,5.227-11.627,11.627V92.8H57.6 c-6.507,0-11.733,5.227-11.733,11.627v395.947c0,6.4,5.227,11.627,11.627,11.627h303.04c6.507,0,11.733-5.227,11.733-11.733v-35.2 h35.2c6.507,0,11.733-5.227,11.733-11.733V419.2h35.2c6.507,0,11.733-5.227,11.733-11.627V128.107 C466.133,126.507,465.813,125.013,465.173,123.627z M348.8,39.68l76.693,76.587H348.8V39.68z M348.8,488.533H69.333V116.267H92.8 V453.44c0,6.4,5.227,11.627,11.627,11.627H348.8V488.533z M395.733,441.6H116.267V69.333h23.467V408 c0,6.187,5.227,11.2,11.627,11.2h244.373V441.6z M442.667,395.733H163.2V23.467h163.2v104.64c0,6.4,5.227,11.627,11.627,11.627 h104.64V395.733z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyV2);
export default __webpack_public_path__ + "static/media/copy-v2.865dffcaa6baa463497da7a89fe9c88c.svg";
export { ForwardRef as ReactComponent };